<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <div :style="style.header">
      <slot name="header" />
    </div>
    <BeatLoader
      v-bind="spinnerProps"
      v-if="spinnerType === 'beat'"
      :loading="true"
      :style="style.spinner"
    />
    <div :style="style.footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import { Layout } from '@js/styles'

  export default {
    name: 'BaseVueSpinner',
    inheritAttrs: false,
    components: {
      BeatLoader,
    },
    props: {
      spinnerProps: { type: Object, required: false, default: () => {} },
      spinnerType: { type: String, required: false, default: 'beat' },
      styleConfig: { type: Object, required: false, default: () => {} },
    },
    data: function () {
      return {
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
          },
          footer: {},
          header: {},
          spinner: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );

      Object.assign(
        this.style.footer,
        this.styleConfig.footer,
      );

      Object.assign(
        this.style.header,
        this.styleConfig.header,
      );

      Object.assign(
        this.style.spinner,
        this.styleConfig.spinner,
      );
    },
  };
</script>
